import { map } from "lodash-es";
import { FC, HTMLAttributes } from "react";
import { useStyles } from "./RecentActivitiesLoading.style";
import clsx from "classnames";
import { Skeleton } from "@onmo/ui";

export const RecentActivitiesLoading: FC<HTMLAttributes<HTMLDivElement>> = (
  props,
) => {
  const classes = useStyles();
  const { ...othersProps } = props;

  return (
    <div {...othersProps} className={clsx(classes.root, othersProps.className)}>
      <Skeleton variant="rect" className={classes.date} />
      {map(Array(4), (_, index) => (
        <div key={index}>
          {map(Array(2), (_, index) => (
            <Skeleton
              variant="rect"
              className={classes.activityItem}
              key={index}
            />
          ))}
        </div>
      ))}
    </div>
  );
};
